import { useQuery } from "@tanstack/react-query";
import { useDebounce } from "use-debounce";
import api from "../../api/axios";

export interface UserLite {
  id: number;
  email: string;
  avatarUrl: string | null;
}

export function useUsersSearch(query: string) {
  const [debounced] = useDebounce(query, 300);

  return useQuery({
    queryKey: ["users", debounced],
    queryFn: async (): Promise<UserLite[]> => {
      const { data } = await api.get("/usuarios", {
        params: { query: debounced },
      });
      return data;
    },
    enabled: !!debounced, // no dispara si la caja está vacía
    staleTime: 5 * 60 * 1000,
  });
}
